/**
 * Sanitizes filename by replacing special characters with underscores
 * @param {string} filename - Original filename
 * @returns {string} - Sanitized filename in lowercase
 */
export function sanitizeFilename(filename) {
  return filename
    .replace(/[@\s]/g, '_') // Replace @ and spaces with underscores
    .replace(/[^a-zA-Z0-9._-]/g, '_') // Replace other special chars with underscores
    .replace(/_+/g, '_') // Collapse multiple underscores
    .toLowerCase(); // Convert to lowercase
}
